// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class DatabaseRecommendationsPlugin {
   config: any
   databases: any
   dbLimit: any
   minDbLimit: any
   static initClass() {
      // @ts-expect-error TS(2339) FIXME: Property 'states' does not exist on type 'Database... Remove this comment to see the full error message
      this.prototype.states = ['new']
   }
   constructor(configService: any) {
      this.invoke = this.invoke.bind(this)
      this.config = configService.data.results
   }
   invoke(data: any, feed: any) {
      const dbs = data.search.recommendations.databases
      if (dbs && dbs.length) {
         const item = {
            databases: dbs,
            type: 'databaseRecommendations',
            show: this.config.showDBRecommenderResults,
            minDbLimit: 2,
            dbLimit: 2,
            showMore: this.showMore,
            showLess: this.showLess
         }
         return feed.addPositionalItem(item, 1)
      }
   }

   showMore() {
      return this.dbLimit = this.databases.length
   }
   showLess() {
      return this.dbLimit = this.minDbLimit
   }
}
DatabaseRecommendationsPlugin.initClass()


DatabaseRecommendationsPlugin.$inject = ['configService']

angular.module('summonApp.resultsFeedPlugins')
   .service('databaseRecommendationsPlugin', DatabaseRecommendationsPlugin)
